$(document).ready(function () {
  resizeEmotionHeader();

  $(window).resize(function () {

    resizeEmotionHeader();

  });
  navInitialise();
  fixNavbarOnScroll();
});

function resizeEmotionHeader() {

  var bodyMarginTop = $('body').css('marginTop').replace('px', '');
  var bodyMarginBottom = $('body').css('marginBottom').replace('px', '');

  var windowHeight = $(window).height() - bodyMarginTop - bodyMarginBottom;
  $('.homepage .emotion-header').height(windowHeight);
}

function navInitialise() {
  if ($(window).width() >= 993) {
    $('.menu-item').hover(
      function () {},
      function () {
        $(this).find('ul').removeClass('in');
        $(this).find('.link-wrapper a').removeClass('cred');
        $(this).find('>i').removeClass('cred');
      }
    );
    $('.menu-item a').hover(
      function () {
        $(this).parent().parent().find('ul').addClass('in');
        $(this).addClass('cred');
        $(this).parent().parent().find('>i').addClass('cred');
      },
      function () {}
    );
  }
  $('.dropdown-btn.collapsed').click(
    function () {
      if ($('.menu-item').find($(this).attr('data-target')).hasClass('in')) {
        $('.menu-item').find($(this).attr('data-target')).removeClass('in');
        $('.menu-item').find($(this).attr('data-target')).removeClass('open');
      } else {
        $('.menu-item').find($(this).attr('data-target')).addClass('in');
        $('.menu-item').find($(this).attr('data-target')).addClass('open');
      }
    }
  );
}

function fixNavbarOnScroll() {
  $(window).on('scroll', function () {
    scrollPosition = $(this).scrollTop();
    if (scrollPosition >= 100) {
      if ($('#fix-at-scroll').hasClass('desktop-fixed-navbar') == false) {
        $('#fix-at-scroll').addClass('desktop-fixed-navbar');
      }
    } else {
      if ($('#fix-at-scroll').hasClass('desktop-fixed-navbar') == true) {
        $('#fix-at-scroll').removeClass('desktop-fixed-navbar');
      }
    }
  });
}

window.initSwiper = function () {
  var swiper = [];

  $('.swiper-container').each(function (index) {
    var $el = $(this);

    swiper[index] = $el.swiper({
      speed: 400,
      pagination: $el.find('.swiper-pagination')[0],
      paginationClickable: true,
      autoplay: ($('body').hasClass('neos-backend') ? 10000 : false),
      autoplayDisableOnInteraction: false,
      simulateTouch: false
    });

    $el.find('.prev-slide').on('click', function () {
      swiper[index].slidePrev();
    });

    $el.find('.next-slide').on('click', function () {
      swiper[index].slideNext();
    });

    positionSwipperBullets();

    $(window).resize(function () {
      updateSwipers();
      positionSwipperBullets();
    });
  });
}
